<script>
import GuestDocumentationMixin from '@/mixins/guestdocumentation'

import { SELLING_REGIONS } from '@/constants'

import { helpers } from '@/helpers.js'

// isMenuToggle: toggleMenu()
// isModalToggle: toggleModal()
// showCover: toggleCover()

export default {
  name: 'GuestDocumentationTtcGroups',
  mixins: [ GuestDocumentationMixin ],
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      isModalWhoWeAreVideoToggle: false,
      isModalTravelStylesVideoToggle: false,
      isModalTreadrightVideoToggle: false,
      constants: {
        SELLING_REGIONS
      }
    }
  },
  methods: {
    isInvalidContent (field = '') {
      return helpers.isInvalidContent(field)
    },
    toggleTermsAndConditionsModal () {
      this.isModalTermsAndConditionsToggle = !this.isModalTermsAndConditionsToggle
      document.body.classList.toggle('modal-open', this.isModalTermsAndConditionsToggle)
    },
    toggleWhoWeAreVideoModal () {
      this.isModalWhoWeAreVideoToggle = !this.isModalWhoWeAreVideoToggle
      document.body.classList.toggle('modal-open', this.isModalWhoWeAreVideoToggle)
    },
    toggleTravelStylesVideoModal () {
      this.isModalTravelStylesVideoToggle = !this.isModalTravelStylesVideoToggle
      document.body.classList.toggle('modal-open', this.isModalTravelStylesVideoToggle)
    },
    toggleTreadrightVideoModal () {
      this.isModalTreadrightVideoToggle = !this.isModalTreadrightVideoToggle
      document.body.classList.toggle('modal-open', this.isModalTreadrightVideoToggle)
    },
    scrollMeTo (refName) {
      var element = document.getElementById(refName)
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      })
    },
    scrollMeDay (dd) {
      var element = document.getElementById(dd)
      var modal = document.getElementById('modal-fullscreen')
      modal.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      })
    },
    printPage () {
      window.print()
    }
  }
}

</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
@import './print.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated delay-1s slow fadeIn">

      <!-- Begin of menu icon toggler -->
      <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu" >
        <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-title">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img class="light-logo" src="/guestdocumentation/ttc-groups/img/logo.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
          <img src="/guestdocumentation/ttc-groups/img/logo.png" alt="Logo" class="light-logo menu-logo">
          <div class="divider-menu">
          </div>
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a class="nav-link" href="#home" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('home')">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
             <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#hotel" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('hotel')">Hotels</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#experiences" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('experiences')">Optional Experiences</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main class="page-main main-anim scrollpage-container animated fadeIn" id="mainpage">
      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[ firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/guestdocumentation/ttc-groups/img/bg-style-1.jpg)'}]">

        <div class="overlay-home" ></div>
        <div class="section-wrapper animated delay-1s slow fadeIn home-flex">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">

                <div class="cover-header-description text-center" >
                  <div class="location" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                    <i class="fa fa-map-marker" ></i>
                    <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
                  </div>
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                    </h1>
                    <div class="cover-header-description-title2" v-if="d && d.itineraries">
                      {{ d.itineraries.titleitinerary }}
                    </div>
                    <div class="cover-header-description-title3">
                      <span class="oppor_type">
                        <span>Guest documentation</span>
                      </span>
                      <span class="txt-uppercase" v-if="d && d.properties_opportunity && d.reference_number">
                        {{ d.reference_number }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <footer class="section-footer scrolldown" >
            <a class="down" @click="scrollMeTo('introduction')">
              <span class="icon"></span>
              <span class="txt">INTRODUCTION</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section fl-porto bg-level-1" data-section="introduction" id="introduction" >
        <div class="section-wrapper with-margin">
          <div class="row">
            <div class="col-12 col-md-12">
              <div class="section-tittle text-center no-print">
                <img class="ttcimage" src="/guestdocumentation/ttc-groups/img/ttc_welcome.jpg">
                <div class="ttcwelcome">WELCOME TO <span>TTC</span></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <div class="paddig-container">
               <!--PRINT: INTRODUCTION-->
                 <table id="print-header" class="print-only">
                    <tbody>
                       <tr>
                          <td width="60%">
                             <h1 class="title_trip_info">TRIP<br><span class="title-info">INFORMATION</span></h1>
                          </td>
                          <td width="10%"></td>
                          <td class="total-value" width="30%">
                             <div id="logo" class="logo_print">
                              <img v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id" class="light-logo" src="/guestdocumentation/ttc-groups/img/logo_print.png" alt="Logo"  width="100" height="100">
                              <img v-else class="light-logo" src="/guestdocumentation/ttc-groups/img/logo_print.png" alt="Logo" width="100" height="100">
                             </div>
                          </td>
                       </tr>
                       <tr>
                          <td width="60%" v-if="d && d.itineraries">
                            <div class="border-trip-name">
                             <h4>{{ d.itineraries.titleitinerary }}</h4>
                            </div>
                          </td>
                          <td width="10%"></td>
                          <td class="trip-code-section" width="30%">
                            <div class="print_info_it">
                              <p id="trip-code-number-section" v-if="d && d.properties_opportunity && d.reference_number">CODE<strong id="trip-code">{{ d.reference_number }}</strong></p>
                              <p id="trip-date-section" v-if="d && d.itineraries">DATE<strong id="trip-code">{{ d.itineraries.fromitinerary | custom-date }}</strong></p>
                             </div>
                          </td>
                       </tr>
                    </tbody>
                 </table>
               <!--PRINT: INTRODUCTION-->
              </div>
              <!-- title and description -->
              <div
                class="title-desc anim-4 paddig-container letter-information"
                v-html="d.guest_documentation.introduction">
              </div>
              <button class="btn btn-radius btn-red mb-0 button_print" @click="printPage">Print <i class="fa fa-print"></i></button>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section bg-level-2" data-section="itinerary" id="itinerary" >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle text-center">
              <div class="cover-header-description-title2 title-sections scrolled">Your Travel Itinerary</div>
              <div class="cover-header-description-title3" v-if="d && d.itineraries">
                {{ d.itineraries.titleitinerary }}
              </div>
              <div class="cover-header-description-title4">
                <i class="icon fa fa-calendar"></i>
                <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                <i class="fa fa-arrow-right"></i>
                <i class="icon fa fa-calendar"></i>
                <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                <i v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)" class="fa fa-map-marker"></i>
                <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
              </div>
            </div>
            <!--PRINT: YOUR TRAVEL ITINERARY-->
            <table id="days-box" class="print-only">
              <tbody>
                 <tr :id="`day${index}`" v-for="(day, index) in d.itineraries.days" :key="index">
                    <td width="100%">
                       <h4 class="title-day-date">DAY {{ index + 1}} <span class="title-day" v-html="day.title"></span></h4>
                      <p class="dl-print">
                      <span v-if="day" class="date">{{ day.startdate | custom-date }}</span> / <span class="location" v-if="day && day.locations && Array.isArray(day.locations)" > <span>{{ day.locations | custom-join('name') }}</span>
                    </span>
                    </p>
                        <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                        <p v-if="day.meals">
                          <strong class="mr-1">MEAL(S):</strong>
                          <span>{{ day.meals | custom-join('mealsday') }}</span>
                        </p>
                        <p v-if="day.accommodation">
                        <strong class="mr-1">ACCOMMODATION:</strong>
                        <span>{{ day.accommodation}}</span>
                      </p>

                    </td>
                 </tr>
              </tbody>
            </table>
            <!--PRINT: YOUR TRAVEL ITINERARY-->

            <div class="row row-random grid-media-aside-text fade-3 no-print">
                <div class="col-md-4 border-card" v-for="(day, index) in d.itineraries.days" :key="index" @click="dayScrollTo(index)">
                  <div class="card gallery-day" data-toggle="modal" data-target="#modal-fullscreen">
                    <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
                    <img v-if="!day.url_image_1200_725" src="/guestdocumentation/ttc-groups/img/day-img.jpg"/>
                    <div class="info text-center">
                      <p class="day_position">day {{ day.startday }}</p>
                      <h1 class="title-day" v-html="day.title"></h1>
                      <p>
                        <i class="icon fa fa-calendar mr-2"></i>
                        <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                      </p>
                      <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                        <i class="fa fa-map-marker mr-2"></i>
                        <span >{{ day.locations | custom-join('name') }}</span>
                      </p>
                    </div>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->
      <!-- Begin of description section -->
      <div class="section section-register bg-level-1 no-print" data-section="map" id="map" >
        <div class="section-wrapper with-margin pb-0">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-center">
                <div class="title-desc">
                  <h2 class="title-sections-blue title-sections no-print map_print_title">Map</h2>
                  <div class="title-print print-only"><h2 class="display-5 anim-2">Map</h2></div>
                  <p class="mb-5 mt-3 no-print">Map route is to be used as a guide for illustration purposes only, and does not represent the exact path taken.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div class="col-12 col-md-12 p0">
          <div class="section-maps">
            <Map :locations="locationsVisited" />
          </div>
        </div>
      </div>
      <!-- Begin of description section -->
      <div class="section fullscreen-md-off bg-level-3 bg-fixed" data-section="hotel" id="hotel"
        :style="[secondOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      secondOpporunityBackgroundImage
                    )}')`
                  } : {'background-image': '/guestdocumentation/ttc-groups/img/bg-style-1.jpg'}]">
        <div class="section-wrapper with-margin section-hotel bg-overlay">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="section-info white">
                  <h1 class="title-sections title-sections-blue">Hotel List</h1>
                  <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Hotel List</h1></div>
                  <br>
                  <div>
                      <div class="section-column">
                          <div v-html="d.guest_documentation.hotel_list">
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Begin of description section -->
      <div class="section fullscreen-md-off bg-level-1 no-footer no-print" data-section="about" id="about" >
        <div class="section-wrapper">
          <div>
            <div class="row">
              <div class="col-12 col-md-4 p0">
                  <div class="card gallery-day justify-content-center card-about" @click.prevent="toggleWhoWeAreVideoModal">
                    <div class="info-about">
                      <img src="/guestdocumentation/ttc-groups/img/whoweare.jpg"/>
                      <div class="info text-center">
                        <h1 class="title-day text-center">WHO WE ARE</h1>
                        <button type="button" class="button button-play button-play-about"></button>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="col-12 col-md-4 p0">
                  <div class="card gallery-day justify-content-center card-about" @click.prevent="toggleTravelStylesVideoModal">
                    <div class="info-about">
                      <img src="/guestdocumentation/ttc-groups/img/travelstyles.jpg"/>
                      <div class="info text-center">
                        <h1 class="title-day text-center">TRAVEL STYLES</h1>
                        <button type="button" class="button button-play button-play-about"></button>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="col-12 col-md-4 p0">
                  <div class="card gallery-day justify-content-center card-about" @click.prevent="toggleTreadrightVideoModal">
                    <div class="info-about">
                      <img src="/guestdocumentation/ttc-groups/img/treadright.jpg"/>
                      <div class="info text-center">
                        <h1 class="title-day text-center">TREADRIGHT</h1>
                        <button type="button" class="button button-play button-play-about"></button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Begin of description section -->
      <div class="section fullscreen-md-off bg-level-2 bg-fixed" data-section="experiences" id="experiences"
        :style="[thirdOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      thirdOpporunityBackgroundImage
                    )}')`
                  } : {'background-image': '/guestdocumentation/ttc-groups/img/bg-style-1.jpg'}]" v-if="!isInvalidContent(d.guest_documentation.optional_experience)">
        <div class="section-wrapper with-margin bg-overlay">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="section-info light-blue  pr-4">
                  <h1 class="title-sections title-sections-blue">Optional Experiences</h1>
                    <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Optional Experiences</h1></div>
                  <div>
                  <br>
                  <div v-html="d.guest_documentation.optional_experience"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer >
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br>
            <img src="/guestdocumentation/ttc-groups/img/logo-itp.png" width="80">
          </div>
          <div class="detail">All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}</div>
        </div>
      </footer>

    </main>
    <!-- Modal Fullscreen -- WHO WE ARE -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-who-we-are" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalWhoWeAreVideoToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalWhoWeAreVideoToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleWhoWeAreVideoModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content modal-video-content">
            <div class="modal-body">
              <div
                class="video-modal">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/l-srUJ1GQXU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Fullscreen -- TRAVEL STYLES -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-travel-styles" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTravelStylesVideoToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTravelStylesVideoToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTravelStylesVideoModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content modal-video-content">
            <div class="modal-body">
              <div
                class="video-modal">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/X7t9tZXgWO4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Fullscreen -- TREADRIGHT -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-treadright" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTreadrightVideoToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTreadrightVideoToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTreadrightVideoModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content modal-video-content">
            <div class="modal-body">
              <div
                class="video-modal">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/tJDwHFOIXDs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-terms-and-conditions-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTermsAndConditionsToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTermsAndConditionsToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTermsAndConditionsModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content  ">
            <div class="modal-body">
              <div class="title-desc "><h3 class="h2 title-sections-2 title-sections-blue pt-3">Terms & Conditions</h3></div>
              <div
                class="title-desc anim-4 paddig-container scrollable terms-information"
                v-html="d.itineraries.terms_conditions">
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="section-header">
        <img class="light-logo" src="/guestdocumentation/ttc-groups/img/logo.png" alt="Logo">
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content  ">
          <div class="modal-body">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/guestdocumentation/ttc-groups/img/day-img.jpg"/>
                </div>
                <div class="col-md-6 section-text pl-0">
                  <div class="align-vcenter text-center">
                    <h1>Day {{ index + 1}}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date text-uppercase title-sections-blue fw-500">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p class="location mt-2 text-uppercase title-sections-blue fw-500" v-if="day && day.locations && Array.isArray(day.locations)" >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p class="day-information" v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span v-html="day.accommodation"></span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday"
                  v-if="index != Object.keys(d.itineraries.days).length - 1">
                    <a class="down" @click="scrollMeDay(`day${index+1}`)">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                  <footer class="section-footer scrolldownDay nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
